// Texts the customizer code shows on its own: fallbacks for Builder options that are
// left empty, error states and labels without a Builder option. Builder options always
// win; these texts only fill the gaps. The shop language comes from Shopify
// (window.Shopify.locale, or <html lang> set from request.locale) and German is the
// default for unknown languages and the Builder preview. Informal address everywhere.

const DEFAULT_LANGUAGE = "de";

export const TEXTS = {
    de: {
        draftLoadError: "Dein Entwurf konnte nicht geladen werden. Bitte aktualisiere die Seite oder starte neu.",
        previewLoadError: "Deine Preview konnte nicht geladen werden. Bitte aktualisiere die Seite oder starte neu.",
        bookLoadingStuck: "Aktuell ist viel los, aber keine Sorge - wir generieren dein Buch trotzdem! Bitte hab noch einen Moment Geduld.",
        merchLoadingStuck: "Einen Moment noch, wir generieren dein Produkt...",
        retry: "Erneut versuchen",
        fallbackTitle: "Der Customizer konnte nicht geladen werden.",
        fallbackMessage: "Bitte öffne den Produktlink erneut oder lade die Seite neu.",
        backToShop: "Zurück zum Shop",
        upsellHeadline: "Aktuelle Sonderangebote",
        upsellAdd: "Hinzufügen",
        upsellImageAlt: "Upsell Produkt",
        upsellSelectQuantity: "Menge auswählen",
        upsellIncrease: "Menge erhöhen",
        upsellDecrease: "Menge verringern",
        upsellRemove: "Add-on entfernen",
        upsellMaxReached: "Maximale Menge {max} erreicht",
        imageUploadTitle: "Bild Upload",
        addImageOptional: "Bild hinzufügen (optional)",
        howItWorks: "Wie funktioniert das?",
        fillManually: "Oder manuell ausfüllen",
        eyeColor: "Augenfarbe",
        skinColor: "Hautfarbe",
        hairstyle: "Frisur",
        specialFeatures: "Besondere Merkmale",
        hairstylePlaceholder: "z.B. Langes blondes gewelltes Haar.",
        specialFeaturesPlaceholder: "z.B. Großes Lächeln, offenes Haar, rotes Hemd und silberne Ohrringe.",
        aiIntro: "Unsere KI überprüft dein Bild und füllt die Eingabefelder automatisch aus.",
        recommendationsTitle: "Unsere Empfehlungen:",
        recommendations: "Gutes Licht;Gut sichtbares Gesicht inkl. Haare;Maximal 5 MB Größe",
        privacy: "Die Bilder werden nicht für eigene Werbeinteressen genutzt und nicht auf eigenen Servern gespeichert. (DSGVO konform)",
        uploadImage: "Bild hochladen",
        mediaLibrary: "Bild aus Mediathek",
        openCamera: "Kamera öffnen",
        imagePreviewAlt: "Bildvorschau",
        uploadErrorTitle: "Fehler beim Hochladen",
        uploadErrorMessage: "Das Bild konnte nicht hochgeladen werden. Bitte versuche es erneut.",
        emailPlaceholder: "Deine E-Mail-Adresse",
        submit: "Absenden",
        sending: "Wird gesendet...",
        sent: "Gesendet!",
        emailInvalid: "Bitte gib eine gültige E-Mail-Adresse ein.",
        submitError: "Es ist ein Fehler aufgetreten. Bitte versuche es später erneut.",
        dateFormatError: "Bitte gib das Datum im Format %format% ein.",
        fieldRequired: "Dieses Feld ist erforderlich.",
        changeErrorTitle: "Das hat leider nicht geklappt",
        changeErrorText: "Deine Änderung konnte gerade nicht angezeigt werden. Bitte lade die Seite in einer Minute neu. Fehlt sie dann noch, versuche es einfach noch einmal.",
        noChangesLeft: "Keine Änderungen mehr möglich",
    },
    en: {
        draftLoadError: "Your draft couldn't be loaded. Please refresh the page or start over.",
        previewLoadError: "Your preview couldn't be loaded. Please refresh the page or start over.",
        bookLoadingStuck: "It's busy right now, but don't worry - we're still creating your book! Please hang on a moment.",
        merchLoadingStuck: "Just a moment, we're creating your product...",
        retry: "Try again",
        fallbackTitle: "The personalization page couldn't be loaded.",
        fallbackMessage: "Please open the product link again or reload the page.",
        backToShop: "Back to shop",
        upsellHeadline: "Current special offers",
        upsellAdd: "Add",
        upsellImageAlt: "Add-on product",
        upsellSelectQuantity: "Select quantity",
        upsellIncrease: "Increase quantity",
        upsellDecrease: "Decrease quantity",
        upsellRemove: "Remove add-on",
        upsellMaxReached: "Maximum quantity of {max} reached",
        imageUploadTitle: "Photo upload",
        addImageOptional: "Add photo (optional)",
        howItWorks: "How does it work?",
        fillManually: "Or fill in manually",
        eyeColor: "Eye color",
        skinColor: "Skin tone",
        hairstyle: "Hairstyle",
        specialFeatures: "Distinctive features",
        hairstylePlaceholder: "e.g. Long, blonde, wavy hair.",
        specialFeaturesPlaceholder: "e.g. Big smile, hair down, red shirt and silver earrings.",
        aiIntro: "Our AI checks your photo and fills in the fields automatically.",
        recommendationsTitle: "Our recommendations:",
        recommendations: "Good lighting;Face and hair clearly visible;Max. 5 MB file size",
        privacy: "Your photos are not used for our own advertising and are not stored on our servers. (GDPR compliant)",
        uploadImage: "Upload photo",
        mediaLibrary: "Choose from library",
        openCamera: "Open camera",
        imagePreviewAlt: "Photo preview",
        uploadErrorTitle: "Upload failed",
        uploadErrorMessage: "Your photo couldn't be uploaded. Please try again.",
        emailPlaceholder: "Your email address",
        submit: "Send",
        sending: "Sending...",
        sent: "Sent!",
        emailInvalid: "Please enter a valid email address.",
        submitError: "Something went wrong. Please try again later.",
        dateFormatError: "Please enter the date in the format %format%.",
        fieldRequired: "This field is required.",
        changeErrorTitle: "Sorry, that didn't work",
        changeErrorText: "Your change couldn't be displayed just now. Please reload the page in a minute. If it's still missing, simply try again.",
        noChangesLeft: "No more changes possible",
    },
    es: {
        draftLoadError: "No pudimos cargar tu borrador. Actualiza la página o empieza de nuevo.",
        previewLoadError: "No pudimos cargar tu vista previa. Actualiza la página o empieza de nuevo.",
        bookLoadingStuck: "Ahora mismo hay mucha demanda, pero no te preocupes: ¡seguimos creando tu libro! Ten un poco más de paciencia.",
        merchLoadingStuck: "Un momento, estamos creando tu producto...",
        retry: "Intentar de nuevo",
        fallbackTitle: "No pudimos cargar la página de personalización.",
        fallbackMessage: "Abre de nuevo el enlace del producto o recarga la página.",
        backToShop: "Volver a la tienda",
        upsellHeadline: "Ofertas especiales",
        upsellAdd: "Agregar",
        upsellImageAlt: "Producto adicional",
        upsellSelectQuantity: "Elegir cantidad",
        upsellIncrease: "Aumentar cantidad",
        upsellDecrease: "Disminuir cantidad",
        upsellRemove: "Quitar extra",
        upsellMaxReached: "Cantidad máxima de {max} alcanzada",
        imageUploadTitle: "Subir foto",
        addImageOptional: "Agregar foto (opcional)",
        howItWorks: "¿Cómo funciona?",
        fillManually: "O complétalo manualmente",
        eyeColor: "Color de ojos",
        skinColor: "Tono de piel",
        hairstyle: "Peinado",
        specialFeatures: "Rasgos especiales",
        hairstylePlaceholder: "p. ej. Pelo largo, rubio y ondulado.",
        specialFeaturesPlaceholder: "p. ej. Gran sonrisa, pelo suelto, camisa roja y aretes plateados.",
        aiIntro: "Nuestra IA revisa tu foto y completa los campos automáticamente.",
        recommendationsTitle: "Nuestras recomendaciones:",
        recommendations: "Buena iluminación;Cara y pelo bien visibles;Máximo 5 MB",
        privacy: "Las fotos no se usan para fines publicitarios propios ni se guardan en nuestros servidores. (Conforme al RGPD)",
        uploadImage: "Subir foto",
        mediaLibrary: "Elegir de la galería",
        openCamera: "Abrir cámara",
        imagePreviewAlt: "Vista previa de la foto",
        uploadErrorTitle: "Error al subir",
        uploadErrorMessage: "No pudimos subir la foto. Inténtalo de nuevo.",
        emailPlaceholder: "Tu correo electrónico",
        submit: "Enviar",
        sending: "Enviando...",
        sent: "¡Enviado!",
        emailInvalid: "Ingresa un correo electrónico válido.",
        submitError: "Algo salió mal. Inténtalo de nuevo más tarde.",
        dateFormatError: "Ingresa la fecha en el formato %format%.",
        fieldRequired: "Este campo es obligatorio.",
        changeErrorTitle: "Lo sentimos, no funcionó",
        changeErrorText: "No pudimos mostrar tu cambio en este momento. Recarga la página en un minuto. Si sigue sin aparecer, inténtalo de nuevo.",
        noChangesLeft: "Ya no puedes hacer más cambios",
    },
    "pt-BR": {
        draftLoadError: "Não foi possível carregar seu rascunho. Atualize a página ou comece de novo.",
        previewLoadError: "Não foi possível carregar sua prévia. Atualize a página ou comece de novo.",
        bookLoadingStuck: "Estamos com muita demanda agora, mas não se preocupe: continuamos criando seu livro! Aguarde só mais um momento.",
        merchLoadingStuck: "Só um momento, estamos criando seu produto...",
        retry: "Tentar novamente",
        fallbackTitle: "Não foi possível carregar a página de personalização.",
        fallbackMessage: "Abra novamente o link do produto ou recarregue a página.",
        backToShop: "Voltar para a loja",
        upsellHeadline: "Ofertas especiais",
        upsellAdd: "Adicionar",
        upsellImageAlt: "Produto adicional",
        upsellSelectQuantity: "Escolher quantidade",
        upsellIncrease: "Aumentar quantidade",
        upsellDecrease: "Diminuir quantidade",
        upsellRemove: "Remover adicional",
        upsellMaxReached: "Quantidade máxima de {max} atingida",
        imageUploadTitle: "Enviar foto",
        addImageOptional: "Adicionar foto (opcional)",
        howItWorks: "Como funciona?",
        fillManually: "Ou preencha manualmente",
        eyeColor: "Cor dos olhos",
        skinColor: "Tom de pele",
        hairstyle: "Penteado",
        specialFeatures: "Características especiais",
        hairstylePlaceholder: "ex.: Cabelo longo, loiro e ondulado.",
        specialFeaturesPlaceholder: "ex.: Sorriso largo, cabelo solto, camisa vermelha e brincos prateados.",
        aiIntro: "Nossa IA analisa sua foto e preenche os campos automaticamente.",
        recommendationsTitle: "Nossas recomendações:",
        recommendations: "Boa iluminação;Rosto e cabelo bem visíveis;Máximo de 5 MB",
        privacy: "As fotos não são usadas para publicidade própria nem armazenadas em nossos servidores. (Em conformidade com o RGPD)",
        uploadImage: "Enviar foto",
        mediaLibrary: "Escolher da galeria",
        openCamera: "Abrir câmera",
        imagePreviewAlt: "Prévia da foto",
        uploadErrorTitle: "Erro no envio",
        uploadErrorMessage: "Não foi possível enviar a foto. Tente novamente.",
        emailPlaceholder: "Seu e-mail",
        submit: "Enviar",
        sending: "Enviando...",
        sent: "Enviado!",
        emailInvalid: "Digite um e-mail válido.",
        submitError: "Algo deu errado. Tente novamente mais tarde.",
        dateFormatError: "Digite a data no formato %format%.",
        fieldRequired: "Este campo é obrigatório.",
        changeErrorTitle: "Infelizmente não deu certo",
        changeErrorText: "Não foi possível exibir sua alteração agora. Recarregue a página em um minuto. Se ela ainda não aparecer, tente novamente.",
        noChangesLeft: "Não é possível fazer mais alterações",
    },
    fr: {
        draftLoadError: "Ton brouillon n'a pas pu être chargé. Actualise la page ou recommence.",
        previewLoadError: "Ton aperçu n'a pas pu être chargé. Actualise la page ou recommence.",
        bookLoadingStuck: "Il y a beaucoup de monde en ce moment, mais pas d'inquiétude : nous créons quand même ton livre ! Encore un peu de patience.",
        merchLoadingStuck: "Encore un instant, nous créons ton produit...",
        retry: "Réessayer",
        fallbackTitle: "La page de personnalisation n'a pas pu être chargée.",
        fallbackMessage: "Ouvre à nouveau le lien du produit ou recharge la page.",
        backToShop: "Retour à la boutique",
        upsellHeadline: "Offres spéciales du moment",
        upsellAdd: "Ajouter",
        upsellImageAlt: "Produit complémentaire",
        upsellSelectQuantity: "Choisir la quantité",
        upsellIncrease: "Augmenter la quantité",
        upsellDecrease: "Diminuer la quantité",
        upsellRemove: "Retirer l'option",
        upsellMaxReached: "Quantité maximale de {max} atteinte",
        imageUploadTitle: "Importer une photo",
        addImageOptional: "Ajouter une photo (facultatif)",
        howItWorks: "Comment ça marche ?",
        fillManually: "Ou remplis manuellement",
        eyeColor: "Couleur des yeux",
        skinColor: "Couleur de peau",
        hairstyle: "Coiffure",
        specialFeatures: "Signes particuliers",
        hairstylePlaceholder: "ex. : Cheveux longs, blonds et ondulés.",
        specialFeaturesPlaceholder: "ex. : Grand sourire, cheveux détachés, chemise rouge et boucles d'oreilles argentées.",
        aiIntro: "Notre IA analyse ta photo et remplit les champs automatiquement.",
        recommendationsTitle: "Nos recommandations :",
        recommendations: "Bonne lumière;Visage et cheveux bien visibles;5 Mo maximum",
        privacy: "Les photos ne sont pas utilisées à nos propres fins publicitaires et ne sont pas stockées sur nos serveurs. (Conforme au RGPD)",
        uploadImage: "Importer la photo",
        mediaLibrary: "Choisir dans la galerie",
        openCamera: "Ouvrir l'appareil photo",
        imagePreviewAlt: "Aperçu de la photo",
        uploadErrorTitle: "Échec de l'importation",
        uploadErrorMessage: "La photo n'a pas pu être importée. Réessaie.",
        emailPlaceholder: "Ton adresse e-mail",
        submit: "Envoyer",
        sending: "Envoi en cours...",
        sent: "Envoyé !",
        emailInvalid: "Saisis une adresse e-mail valide.",
        submitError: "Une erreur s'est produite. Réessaie plus tard.",
        dateFormatError: "Saisis la date au format %format%.",
        fieldRequired: "Ce champ est obligatoire.",
        changeErrorTitle: "Désolé, ça n'a pas marché",
        changeErrorText: "Ta modification n'a pas pu être affichée pour le moment. Recharge la page dans une minute. Si elle n'apparaît toujours pas, réessaie simplement.",
        noChangesLeft: "Plus aucune modification possible",
    },
    it: {
        draftLoadError: "Non è stato possibile caricare la tua bozza. Aggiorna la pagina o ricomincia.",
        previewLoadError: "Non è stato possibile caricare la tua anteprima. Aggiorna la pagina o ricomincia.",
        bookLoadingStuck: "In questo momento c'è molta richiesta, ma non preoccuparti: stiamo comunque creando il tuo libro! Abbi ancora un attimo di pazienza.",
        merchLoadingStuck: "Ancora un attimo, stiamo creando il tuo prodotto...",
        retry: "Riprova",
        fallbackTitle: "Non è stato possibile caricare la pagina di personalizzazione.",
        fallbackMessage: "Apri di nuovo il link del prodotto o ricarica la pagina.",
        backToShop: "Torna al negozio",
        upsellHeadline: "Offerte speciali del momento",
        upsellAdd: "Aggiungi",
        upsellImageAlt: "Prodotto aggiuntivo",
        upsellSelectQuantity: "Scegli la quantità",
        upsellIncrease: "Aumenta la quantità",
        upsellDecrease: "Diminuisci la quantità",
        upsellRemove: "Rimuovi l'extra",
        upsellMaxReached: "Quantità massima di {max} raggiunta",
        imageUploadTitle: "Carica foto",
        addImageOptional: "Aggiungi foto (facoltativo)",
        howItWorks: "Come funziona?",
        fillManually: "Oppure compila manualmente",
        eyeColor: "Colore degli occhi",
        skinColor: "Colore della pelle",
        hairstyle: "Acconciatura",
        specialFeatures: "Tratti particolari",
        hairstylePlaceholder: "es. Capelli lunghi, biondi e mossi.",
        specialFeaturesPlaceholder: "es. Grande sorriso, capelli sciolti, camicia rossa e orecchini d'argento.",
        aiIntro: "La nostra IA controlla la tua foto e compila i campi automaticamente.",
        recommendationsTitle: "I nostri consigli:",
        recommendations: "Buona luce;Viso e capelli ben visibili;Massimo 5 MB",
        privacy: "Le foto non vengono usate per nostri scopi pubblicitari né salvate sui nostri server. (Conforme al GDPR)",
        uploadImage: "Carica foto",
        mediaLibrary: "Scegli dalla galleria",
        openCamera: "Apri fotocamera",
        imagePreviewAlt: "Anteprima della foto",
        uploadErrorTitle: "Errore di caricamento",
        uploadErrorMessage: "Non è stato possibile caricare la foto. Riprova.",
        emailPlaceholder: "Il tuo indirizzo e-mail",
        submit: "Invia",
        sending: "Invio in corso...",
        sent: "Inviato!",
        emailInvalid: "Inserisci un indirizzo e-mail valido.",
        submitError: "Si è verificato un errore. Riprova più tardi.",
        dateFormatError: "Inserisci la data nel formato %format%.",
        fieldRequired: "Questo campo è obbligatorio.",
        changeErrorTitle: "Purtroppo non ha funzionato",
        changeErrorText: "Non è stato possibile mostrare la tua modifica in questo momento. Ricarica la pagina tra un minuto. Se ancora non compare, riprova.",
        noChangesLeft: "Non sono più possibili modifiche",
    },
    nl: {
        draftLoadError: "Je concept kon niet worden geladen. Vernieuw de pagina of begin opnieuw.",
        previewLoadError: "Je voorbeeld kon niet worden geladen. Vernieuw de pagina of begin opnieuw.",
        bookLoadingStuck: "Het is momenteel erg druk, maar geen zorgen - we maken je boek toch! Nog even geduld.",
        merchLoadingStuck: "Nog even, we maken je product...",
        retry: "Opnieuw proberen",
        fallbackTitle: "De personalisatiepagina kon niet worden geladen.",
        fallbackMessage: "Open de productlink opnieuw of laad de pagina opnieuw.",
        backToShop: "Terug naar de winkel",
        upsellHeadline: "Actuele aanbiedingen",
        upsellAdd: "Toevoegen",
        upsellImageAlt: "Extra product",
        upsellSelectQuantity: "Aantal kiezen",
        upsellIncrease: "Aantal verhogen",
        upsellDecrease: "Aantal verlagen",
        upsellRemove: "Extra verwijderen",
        upsellMaxReached: "Maximaal aantal van {max} bereikt",
        imageUploadTitle: "Foto uploaden",
        addImageOptional: "Foto toevoegen (optioneel)",
        howItWorks: "Hoe werkt het?",
        fillManually: "Of vul het handmatig in",
        eyeColor: "Oogkleur",
        skinColor: "Huidskleur",
        hairstyle: "Kapsel",
        specialFeatures: "Bijzondere kenmerken",
        hairstylePlaceholder: "bijv. Lang, blond, golvend haar.",
        specialFeaturesPlaceholder: "bijv. Grote glimlach, loshangend haar, rood shirt en zilveren oorbellen.",
        aiIntro: "Onze AI bekijkt je foto en vult de velden automatisch in.",
        recommendationsTitle: "Onze tips:",
        recommendations: "Goed licht;Gezicht en haar goed zichtbaar;Maximaal 5 MB",
        privacy: "De foto's worden niet voor eigen reclamedoeleinden gebruikt en niet op onze servers opgeslagen. (AVG-conform)",
        uploadImage: "Foto uploaden",
        mediaLibrary: "Kies uit galerij",
        openCamera: "Camera openen",
        imagePreviewAlt: "Fotovoorbeeld",
        uploadErrorTitle: "Uploaden mislukt",
        uploadErrorMessage: "De foto kon niet worden geüpload. Probeer het opnieuw.",
        emailPlaceholder: "Je e-mailadres",
        submit: "Versturen",
        sending: "Bezig met versturen...",
        sent: "Verstuurd!",
        emailInvalid: "Vul een geldig e-mailadres in.",
        submitError: "Er ging iets mis. Probeer het later opnieuw.",
        dateFormatError: "Vul de datum in als %format%.",
        fieldRequired: "Dit veld is verplicht.",
        changeErrorTitle: "Dat is helaas niet gelukt",
        changeErrorText: "Je wijziging kon nu niet worden weergegeven. Laad de pagina over een minuut opnieuw. Staat ze er dan nog niet, probeer het gewoon nog een keer.",
        noChangesLeft: "Geen wijzigingen meer mogelijk",
    },
    pl: {
        draftLoadError: "Nie udało się wczytać Twojego projektu. Odśwież stronę lub zacznij od nowa.",
        previewLoadError: "Nie udało się wczytać podglądu. Odśwież stronę lub zacznij od nowa.",
        bookLoadingStuck: "Mamy teraz dużo zamówień, ale bez obaw - i tak tworzymy Twoją książkę! Poczekaj jeszcze chwilę.",
        merchLoadingStuck: "Jeszcze chwila, tworzymy Twój produkt...",
        retry: "Spróbuj ponownie",
        fallbackTitle: "Nie udało się wczytać strony personalizacji.",
        fallbackMessage: "Otwórz ponownie link do produktu lub odśwież stronę.",
        backToShop: "Wróć do sklepu",
        upsellHeadline: "Aktualne oferty specjalne",
        upsellAdd: "Dodaj",
        upsellImageAlt: "Produkt dodatkowy",
        upsellSelectQuantity: "Wybierz ilość",
        upsellIncrease: "Zwiększ ilość",
        upsellDecrease: "Zmniejsz ilość",
        upsellRemove: "Usuń dodatek",
        upsellMaxReached: "Osiągnięto maksymalną ilość: {max}",
        imageUploadTitle: "Prześlij zdjęcie",
        addImageOptional: "Dodaj zdjęcie (opcjonalnie)",
        howItWorks: "Jak to działa?",
        fillManually: "Lub wypełnij ręcznie",
        eyeColor: "Kolor oczu",
        skinColor: "Kolor skóry",
        hairstyle: "Fryzura",
        specialFeatures: "Cechy szczególne",
        hairstylePlaceholder: "np. Długie, blond, falowane włosy.",
        specialFeaturesPlaceholder: "np. Szeroki uśmiech, rozpuszczone włosy, czerwona koszula i srebrne kolczyki.",
        aiIntro: "Nasza AI sprawdza Twoje zdjęcie i automatycznie wypełnia pola.",
        recommendationsTitle: "Nasze wskazówki:",
        recommendations: "Dobre światło;Dobrze widoczna twarz i włosy;Maksymalnie 5 MB",
        privacy: "Zdjęcia nie są wykorzystywane do naszych celów reklamowych ani przechowywane na naszych serwerach. (Zgodnie z RODO)",
        uploadImage: "Prześlij zdjęcie",
        mediaLibrary: "Wybierz z galerii",
        openCamera: "Otwórz aparat",
        imagePreviewAlt: "Podgląd zdjęcia",
        uploadErrorTitle: "Błąd przesyłania",
        uploadErrorMessage: "Nie udało się przesłać zdjęcia. Spróbuj ponownie.",
        emailPlaceholder: "Twój adres e-mail",
        submit: "Wyślij",
        sending: "Wysyłanie...",
        sent: "Wysłano!",
        emailInvalid: "Podaj prawidłowy adres e-mail.",
        submitError: "Coś poszło nie tak. Spróbuj ponownie później.",
        dateFormatError: "Wpisz datę w formacie %format%.",
        fieldRequired: "To pole jest wymagane.",
        changeErrorTitle: "Niestety się nie udało",
        changeErrorText: "Nie udało się teraz wyświetlić Twojej zmiany. Odśwież stronę za minutę. Jeśli nadal jej nie będzie, po prostu spróbuj ponownie.",
        noChangesLeft: "Nie można już wprowadzać zmian",
    },
    ro: {
        draftLoadError: "Ciorna ta nu a putut fi încărcată. Reîncarcă pagina sau începe din nou.",
        previewLoadError: "Previzualizarea ta nu a putut fi încărcată. Reîncarcă pagina sau începe din nou.",
        bookLoadingStuck: "Acum este mare aglomerație, dar nu-ți face griji - îți creăm cartea în continuare! Mai ai puțină răbdare.",
        merchLoadingStuck: "Încă un moment, îți creăm produsul...",
        retry: "Încearcă din nou",
        fallbackTitle: "Pagina de personalizare nu a putut fi încărcată.",
        fallbackMessage: "Deschide din nou linkul produsului sau reîncarcă pagina.",
        backToShop: "Înapoi la magazin",
        upsellHeadline: "Oferte speciale actuale",
        upsellAdd: "Adaugă",
        upsellImageAlt: "Produs suplimentar",
        upsellSelectQuantity: "Alege cantitatea",
        upsellIncrease: "Mărește cantitatea",
        upsellDecrease: "Micșorează cantitatea",
        upsellRemove: "Elimină suplimentul",
        upsellMaxReached: "Ai atins cantitatea maximă de {max}",
        imageUploadTitle: "Încarcă fotografia",
        addImageOptional: "Adaugă o fotografie (opțional)",
        howItWorks: "Cum funcționează?",
        fillManually: "Sau completează manual",
        eyeColor: "Culoarea ochilor",
        skinColor: "Culoarea pielii",
        hairstyle: "Coafură",
        specialFeatures: "Trăsături deosebite",
        hairstylePlaceholder: "de ex. Păr lung, blond și ondulat.",
        specialFeaturesPlaceholder: "de ex. Zâmbet larg, păr desfăcut, cămașă roșie și cercei argintii.",
        aiIntro: "AI-ul nostru îți verifică fotografia și completează automat câmpurile.",
        recommendationsTitle: "Recomandările noastre:",
        recommendations: "Lumină bună;Fața și părul bine vizibile;Maximum 5 MB",
        privacy: "Fotografiile nu sunt folosite în scopuri publicitare proprii și nu sunt stocate pe serverele noastre. (Conform GDPR)",
        uploadImage: "Încarcă fotografia",
        mediaLibrary: "Alege din galerie",
        openCamera: "Deschide camera",
        imagePreviewAlt: "Previzualizare fotografie",
        uploadErrorTitle: "Eroare la încărcare",
        uploadErrorMessage: "Fotografia nu a putut fi încărcată. Încearcă din nou.",
        emailPlaceholder: "Adresa ta de e-mail",
        submit: "Trimite",
        sending: "Se trimite...",
        sent: "Trimis!",
        emailInvalid: "Introdu o adresă de e-mail validă.",
        submitError: "A apărut o eroare. Încearcă din nou mai târziu.",
        dateFormatError: "Introdu data în formatul %format%.",
        fieldRequired: "Acest câmp este obligatoriu.",
        changeErrorTitle: "Din păcate, nu a funcționat",
        changeErrorText: "Modificarea ta nu a putut fi afișată acum. Reîncarcă pagina peste un minut. Dacă tot lipsește, încearcă din nou.",
        noChangesLeft: "Nu mai sunt posibile modificări",
    },
    sv: {
        draftLoadError: "Ditt utkast kunde inte laddas. Ladda om sidan eller börja om.",
        previewLoadError: "Din förhandsvisning kunde inte laddas. Ladda om sidan eller börja om.",
        bookLoadingStuck: "Det är mycket just nu, men ingen fara - vi skapar din bok ändå! Ha tålamod en liten stund till.",
        merchLoadingStuck: "Ett ögonblick, vi skapar din produkt...",
        retry: "Försök igen",
        fallbackTitle: "Sidan för personalisering kunde inte laddas.",
        fallbackMessage: "Öppna produktlänken igen eller ladda om sidan.",
        backToShop: "Tillbaka till butiken",
        upsellHeadline: "Aktuella specialerbjudanden",
        upsellAdd: "Lägg till",
        upsellImageAlt: "Tilläggsprodukt",
        upsellSelectQuantity: "Välj antal",
        upsellIncrease: "Öka antal",
        upsellDecrease: "Minska antal",
        upsellRemove: "Ta bort tillägg",
        upsellMaxReached: "Maxantal på {max} uppnått",
        imageUploadTitle: "Ladda upp bild",
        addImageOptional: "Lägg till bild (valfritt)",
        howItWorks: "Hur fungerar det?",
        fillManually: "Eller fyll i manuellt",
        eyeColor: "Ögonfärg",
        skinColor: "Hudfärg",
        hairstyle: "Frisyr",
        specialFeatures: "Särskilda kännetecken",
        hairstylePlaceholder: "t.ex. Långt, blont, vågigt hår.",
        specialFeaturesPlaceholder: "t.ex. Stort leende, utsläppt hår, röd skjorta och silverörhängen.",
        aiIntro: "Vår AI granskar din bild och fyller i fälten automatiskt.",
        recommendationsTitle: "Våra rekommendationer:",
        recommendations: "Bra ljus;Ansikte och hår syns tydligt;Max 5 MB",
        privacy: "Bilderna används inte i egna reklamsyften och sparas inte på våra servrar. (GDPR-kompatibelt)",
        uploadImage: "Ladda upp bild",
        mediaLibrary: "Välj från bildbiblioteket",
        openCamera: "Öppna kameran",
        imagePreviewAlt: "Förhandsvisning av bild",
        uploadErrorTitle: "Uppladdningen misslyckades",
        uploadErrorMessage: "Bilden kunde inte laddas upp. Försök igen.",
        emailPlaceholder: "Din e-postadress",
        submit: "Skicka",
        sending: "Skickar...",
        sent: "Skickat!",
        emailInvalid: "Ange en giltig e-postadress.",
        submitError: "Något gick fel. Försök igen senare.",
        dateFormatError: "Ange datumet i formatet %format%.",
        fieldRequired: "Det här fältet är obligatoriskt.",
        changeErrorTitle: "Det fungerade tyvärr inte",
        changeErrorText: "Din ändring kunde inte visas just nu. Ladda om sidan om en minut. Saknas den fortfarande, försök bara igen.",
        noChangesLeft: "Inga fler ändringar möjliga",
    },
    tr: {
        draftLoadError: "Taslağın yüklenemedi. Lütfen sayfayı yenile veya baştan başla.",
        previewLoadError: "Önizlemen yüklenemedi. Lütfen sayfayı yenile veya baştan başla.",
        bookLoadingStuck: "Şu anda yoğunluk var ama endişelenme - kitabını yine de oluşturuyoruz! Lütfen biraz daha sabret.",
        merchLoadingStuck: "Bir dakika, ürününü oluşturuyoruz...",
        retry: "Tekrar dene",
        fallbackTitle: "Kişiselleştirme sayfası yüklenemedi.",
        fallbackMessage: "Ürün bağlantısını yeniden aç veya sayfayı yenile.",
        backToShop: "Mağazaya dön",
        upsellHeadline: "Güncel özel teklifler",
        upsellAdd: "Ekle",
        upsellImageAlt: "Ek ürün",
        upsellSelectQuantity: "Adet seç",
        upsellIncrease: "Adedi artır",
        upsellDecrease: "Adedi azalt",
        upsellRemove: "Ekstrayı kaldır",
        upsellMaxReached: "En fazla {max} adet seçilebilir",
        imageUploadTitle: "Fotoğraf yükle",
        addImageOptional: "Fotoğraf ekle (isteğe bağlı)",
        howItWorks: "Nasıl çalışır?",
        fillManually: "Ya da elle doldur",
        eyeColor: "Göz rengi",
        skinColor: "Ten rengi",
        hairstyle: "Saç modeli",
        specialFeatures: "Belirgin özellikler",
        hairstylePlaceholder: "ör. Uzun, sarı, dalgalı saç.",
        specialFeaturesPlaceholder: "ör. Kocaman gülümseme, açık saç, kırmızı gömlek ve gümüş küpeler.",
        aiIntro: "Yapay zekamız fotoğrafını inceler ve alanları otomatik olarak doldurur.",
        recommendationsTitle: "Önerilerimiz:",
        recommendations: "İyi ışık;Yüz ve saçlar net görünmeli;En fazla 5 MB",
        privacy: "Fotoğraflar kendi reklam amaçlarımız için kullanılmaz ve sunucularımızda saklanmaz. (GDPR uyumlu)",
        uploadImage: "Fotoğraf yükle",
        mediaLibrary: "Galeriden seç",
        openCamera: "Kamerayı aç",
        imagePreviewAlt: "Fotoğraf önizlemesi",
        uploadErrorTitle: "Yükleme hatası",
        uploadErrorMessage: "Fotoğraf yüklenemedi. Lütfen tekrar dene.",
        emailPlaceholder: "E-posta adresin",
        submit: "Gönder",
        sending: "Gönderiliyor...",
        sent: "Gönderildi!",
        emailInvalid: "Lütfen geçerli bir e-posta adresi gir.",
        submitError: "Bir hata oluştu. Lütfen daha sonra tekrar dene.",
        dateFormatError: "Lütfen tarihi %format% biçiminde gir.",
        fieldRequired: "Bu alan zorunludur.",
        changeErrorTitle: "Maalesef olmadı",
        changeErrorText: "Değişikliğin şu anda gösterilemedi. Lütfen bir dakika sonra sayfayı yenile. Hâlâ görünmüyorsa tekrar dene.",
        noChangesLeft: "Artık değişiklik yapılamaz",
    },
};

export const SUPPORTED_LANGUAGES = Object.keys(TEXTS);

// German texts the Builder editor saved into blocks as field defaults before those
// defaults were removed, where they differ from the German text above.
const SAVED_GERMAN_DEFAULTS = {
    bookLoadingStuck: ["Einen Moment noch, wir generieren dein Buch..."],
    dateFormatError: ["Bitte geben Sie das Datum im Format %format% ein."],
};

// "es-MX" -> "es", "pt" / "pt-PT" -> "pt-BR" (the only Portuguese shop), unknown -> null.
export function normalizeLanguage(value) {
    const code = String(value || "").trim().replace("_", "-").toLowerCase();

    if (!code) {
        return null;
    }

    const base = code.split("-")[0];

    if (base === "pt") {
        return "pt-BR";
    }

    return Object.prototype.hasOwnProperty.call(TEXTS, base) ? base : null;
}

export function getCustomizerLanguage() {
    const candidates = [
        typeof window !== "undefined" ? window.Shopify?.locale : null,
        typeof document !== "undefined" ? document.documentElement?.lang : null,
    ];

    for (const candidate of candidates) {
        const language = normalizeLanguage(candidate);

        if (language) {
            return language;
        }
    }

    return DEFAULT_LANGUAGE;
}

// Returns the text for the current shop language; {name} placeholders are filled from params.
export function customizerText(key, params = {}) {
    const language = getCustomizerLanguage();
    const text = TEXTS[language]?.[key] ?? TEXTS[DEFAULT_LANGUAGE][key] ?? key;

    return text.replace(/\{(\w+)\}/g, (match, name) => (
        Object.prototype.hasOwnProperty.call(params, name) ? String(params[name]) : match
    ));
}

function isGermanDefault(text, key) {
    return text === TEXTS[DEFAULT_LANGUAGE][key] || (SAVED_GERMAN_DEFAULTS[key] || []).includes(text);
}

// Text for a Builder option that has a translated fallback. A text set in Builder wins.
// An empty option shows the text in the shop language, and so does the German standard
// text outside the German shop: that is what the editor saved, not a chosen text.
// keepEmpty: an empty string stays empty, for options where empty hides the element.
export function builderText(value, key, { keepEmpty = false } = {}) {
    const text = typeof value === "string" ? value.trim() : "";

    if (!text) {
        return keepEmpty && typeof value === "string" ? value : customizerText(key);
    }

    if (getCustomizerLanguage() !== DEFAULT_LANGUAGE && isGermanDefault(text, key)) {
        return customizerText(key);
    }

    return value;
}
